import { render, staticRenderFns } from "./LangToggler.vue?vue&type=template&id=58c35b46&scoped=true&"
import script from "./LangToggler.vue?vue&type=script&lang=js&"
export * from "./LangToggler.vue?vue&type=script&lang=js&"
import style0 from "./LangToggler.vue?vue&type=style&index=0&id=58c35b46&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58c35b46",
  null
  
)

export default component.exports